// src/common/components/gMapInput/GMapInput.tsx
import React, { ChangeEvent } from "react";
import { useTheme } from "../../hooks/useTheme";
import { AddressInterface, CityInterface } from "../../types/types";
import styles from "./GMapInput.module.scss";
import { useGMapInput } from "./useGMapInput";

export type GMapInputProps<T> = {
  fieldName: "city" | "address";
  setData: (inputData: T) => void;
  data: T;
  placeHolder: string;
  required?: boolean;
  disabled?: boolean;
};

export const GMapInput = <
  T extends { city: CityInterface; address: AddressInterface },
>({
  fieldName,
  setData,
  data,
  placeHolder,
  required,
}: GMapInputProps<T>) => {
  const { dataReset } = useGMapInput(fieldName, setData, data);
  const { isDark } = useTheme();

  return (
    <div className={styles.container}>
      <input
        className={`${styles.input} ${isDark ? styles.dark : ""}`}
        style={{
          borderLeft:
            required && !data[fieldName].latitude
              ? "2px solid var(--danger)"
              : "",
        }}
        id={fieldName}
        name={fieldName}
        defaultValue={data[fieldName].value}
        placeholder={placeHolder}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          dataReset(e);
        }}
        onBlur={() => {
          const tempData = { ...data };
          tempData[fieldName].isDirty = true;
          setData(tempData);
        }}
      />
      <div className={styles.validationError}>
        {!data[fieldName].latitude &&
          data[fieldName].isDirty &&
          `Выберите ${fieldName === "address" ? "адрес" : "город"} из списка`}
      </div>
    </div>
  );
};
